export default __webpack_public_path__ + "static/media/URINARY-TRACT-INFECTION.f5ed649e.png";